var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showQr),expression:"showQr"}],staticStyle:{"margin":"20px"}},[_c('VueQRCodeComponent',{attrs:{"text":_vm.valueQr,"size":_vm.size,"level":"H","id":"qrcodeImage"}})],1),_c('div',[_c('iframe',{attrs:{"src":_vm.pdfUrl,"height":"1200px","width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }